import { useTranslation } from "react-i18next";

import { AmountFormat, DateFormat } from 'components/common';
import { DocumentDetailsPage } from "components/common/DocumentDetailsPage";
import StepsItemView from "components/common/StepsItemView";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RouteComponentProps, useHistory, useParams } from "react-router-dom";
import { getDocument } from "services/users";
import styled from "styled-components";
import './style.scss';

// const PageWrapper = styled.div`
//   width: 100%;
//   padding-top: 22px;
//   padding-left: 37px;
//   padding-right: 51px;
//   @media (max-width: 900px) {
//     padding: 30px 4px;
//   }
// `;

const config = [
    'Total',
    'Price',
    'Quantity',
    'Currency Type',
    'Type',
    'Approval Date',
    'Step'
];

const PageWrapper = styled.div`
padding-top: 22px;
padding-left: 37px;
padding-right: 51px;
position: relative;
`;

const columns = [
    'Total',
    'Price',
    'Quantity',
    'Currency Type',
    'Type',
    'Approval Date',
    'Step'
];

type RouteParams = {
    id: string;
};

const FeesDetails: React.FC<RouteComponentProps> = () => {
    const { t } = useTranslation();
    const { id } = useParams<RouteParams>();

    const history = useHistory();
    const { user, userCore } = useSelector(
        (state: any) => state.authReducer
    );

    const [document, setDocument] = useState<any>(null);

    const [data, setData] = useState<any>(null);
    const [depositData, setDepositData] = useState<any>(null);
    const [bankDetailsData, setBankDetailsData] = useState<any>(null);
    const [receiptData, setReceiptData] = useState<any>(null);

    /*     const [BAMCId, setBAMCId] = useState<number>();
        const [BAMCStatus, setBAMCStatus] = useState("");
        const [BAMCStatusClass, setBAMCStatusClass] = useState("");
        const [BAMCMeta, setBAMCMeta] = useState<any[]|null>(null);
        const [viewBAMC, setViewBAMC] = useState(false);
     */
    const processDocument = (doc: any) => {
        // console.log(doc);
        setDocument(doc);
        const data: any[] = [{
            id: 0,
            step: 1,
            status: "passed",
            text: t("management_fee_plain"),
            currency_type: "",
            currency: "",
            quantity: "",
            price: "",
            total: "",
            approval_date: "",
            type: ""
        }];
        doc.meta.movements.forEach((item: any) => data.push({
            id: item.id,
            step: null,
            status: "passed",
            text: item.currency + " ⇄ USD",
            currency_type: t("crypto_string"),
            currency: item.currency,
            quantity: Math.abs(item.usd_value),
            quantityDecimals: 4,
            price: Math.abs(item.price),
            priceDecimals: 4,
            total: Math.abs(item.amount),
            totalDecimals: 8,
            approval_date: item.dt,
            type: t("management_fee_plain")
        }));
        setData(data);
    };

    const reloadDocuments = () => {
        getDocument(id).then(doc => {
            if (doc) {
                processDocument(doc);
            }
        });
    };

    useEffect(() => {
        if (!user || !userCore) {
            return history.push('/');
        }
        reloadDocuments();
    }, []);

    useEffect(() => {
        if (!user) {
            return history.push('/');
        }
    }, [user, userCore]);

    /*<PageWrapper id={"deposit-details-page"}>
        <div className={"container-fluid"}>
            <div className={"row"}>
                <div className={"col-xxl-12"}>
                    <div className={"d-flex justify-content-between align-items-end flex-wrap"}>
                        <div className={"d-flex align-items-center"}>
                            <CurrentDate lang={"en"} />
                            <div className={"ms-3"}><BackButton onPress={() => history.goBack()} text={t("back_text")} /></div>
                        </div>
                        <h2 className={"page-title"}>{t("fee_details_string")}</h2>
                    </div>
                    <div className="backoffice-tab-content">
                        <div className={"tab-table-head-back-office"}>
                            <div className={"status-col"}><span className={"col-title"}>{t("status_tag_plain")}</span></div>
                            <div className={"type-col"}><span className={"col-title"}>{t("type_tag_plain")}</span></div>
                            <div className={"approval-col"}><span className={"col-title"}>{t("approval_date_tag_plain")}</span></div>
                            <div className={"date-col"}><span className={"col-title"}>{t("request_date_tag_plain")}</span></div>
                            {/* {!hideAmount && <div className={"amount-col"}><span className={"col-title"}>{t("amount_tag_plain")}</span></div>} *}
                            <div className={"request-col"}><span className={"col-title"}>{t("request_tag_plain")}</span></div>
                        </div>
                        <div className={"backoffice-list-items"}>
                            <div className="backoffice-table-item">
                                <div className={"status-col-val"}>
                                    <div className="mob-label">{t("status_tag_plain")}</div>
                                    <Status status={document?.meta.state} />
                                </div>
                                <div className={"type-col-val"}><div className="mob-label">{t("type_tag_plain")}</div><span className={"col-title"}>{t("crypto_string")}</span></div>
                                <div className={"approval-col-val"}><div className="mob-label">{t("approval_date_tag_plain")}</div><span className={"col-title"}>{document && <DateFormat date={document.dt} lang="en" />}</span></div>
                                <div className={"date-col-val"}><div className="mob-label">{t("request_date_tag_plain")}</div><span className={"col-title"}>{document && <DateFormat date={document.dt} lang="en" />}</span></div>
                                {/* {!hideAmount && <div className={"amount-col-val"}><div className="mob-label">{t("amount_tag_plain")}</div><span className={"col-title"}>{documentData && <AmountFormat amount={documentData.meta.amount} />}</span></div> } *}
                                <div className={"request-col-val"}><div className="mob-label">{t("request_tag_plain")}</div><span className="col-title">{document && ('#' + document.id)}</span></div>
                            </div>
                        </div>
                    </div>
                    <div className="deposit-details-sub">{t("fee_tag_plain")}</div>
                    <div className="backoffice-tab-content">
                        <div className={"tab-table-head-back-office"}>
                            <div className={"branch-col"}><span className={"col-title"}>{t("nis_usd_rate_tag_plain")}</span></div>
                            <div className={"acc-number-col"}><span className={"col-title"}>{t("management_fee_nis_plain")}</span></div>
                            <div className={"branch-col"}><span className={"col-title"}>{t("management_fee_percent_plain")}</span></div>
                            <div className={"bankname-col"}><span className={"col-title"}>{t("portfolio_value_plain")}</span></div>
                            <div className={"username-col"}><span className={"col-title"}>{t("date_tag_plain")}</span></div>
                        </div>
                        <div className={"backoffice-list-items"}>
                            <div className="backoffice-table-item">
                                <div className={"branch-col-val"}>
                                    <div className="mob-label">{t("nis_usd_rate_tag_plain")}</div>
                                    <span className={"col-title"}>
                                        <AmountFormat amount={document?.meta?.rates?.usdt2NisPrice} decimals={2} />
                                    </span>
                                </div>
                                <div className={"acc-number-col-val"}><div className="mob-label">{t("management_fee_nis_plain")}</div><span className={"col-title"}>
                                    <AmountFormat amount={-document?.meta?.applied_fee_value} decimals={2} />
                                </span></div>
                                <div className={"branch-col-val"}><div className="mob-label">{t("management_fee_percent_plain")}</div><span className={"col-title"}>
                                    <AmountFormat amount={document?.meta?.applied_fee_percentage} decimals={2} />%
                                </span></div>
                                <div className={"bankname-col-val"}><div className="mob-label">{t("portfolio_value_plain")}</div><span className={"col-title"}>
                                    <AmountFormat amount={document?.meta?.portfolio_nis_value} decimals={3} />
                                </span></div>
                                <div className={"name-col-val"}>
                                    <div className="mob-label">{t("date_tag_plain")}</div>
                                    <DateFormat date={document?.dt} lang="en" />
                                </div>
                            </div>
                        </div>
                    </div>
                    {data && <StepsContentGrid config={columns} data={data} processing={false} itemComponent={StepsItemView} />}
                </div>
            </div>
        </div>
                </PageWrapper>
*/
    return (
        <DocumentDetailsPage
            title={t("fee_details_string")}
            columns={config}
            documentData={document}
            bankDetails={bankDetailsData}
            stepsData={data}
            processing={false}
            itemComponent={StepsItemView}
            summary={(
                <><div className="deposit-details-sub">{t("fee_tag_plain")}</div>
                    <div className="backoffice-tab-content">
                        <div className={"tab-table-head-back-office"}>
                            <div className={"branch-col"}><span className={"col-title"}>{t("nis_usd_rate_tag_plain")}</span></div>
                            <div className={"acc-number-col"}><span className={"col-title"}>{t("management_fee_nis_plain")}</span></div>
                            <div className={"branch-col"}><span className={"col-title"}>{t("management_fee_percent_plain")}</span></div>
                            <div className={"bankname-col"}><span className={"col-title"}>{t("portfolio_value_plain")}</span></div>
                            <div className={"username-col"}><span className={"col-title"}>{t("date_tag_plain")}</span></div>
                        </div>
                        <div className={"backoffice-list-items"}>
                            <div className="backoffice-table-item">
                                <div className={"branch-col-val"}>
                                    <div className="mob-label">{t("nis_usd_rate_tag_plain")}</div>
                                    <span className={"col-title"}>
                                        <AmountFormat amount={document?.meta?.rates?.usd2NisPrice ?? document?.meta?.rates?.usdt2NisPrice} decimals={4} />
                                    </span>
                                </div>
                                <div className={"acc-number-col-val"}><div className="mob-label">{t("management_fee_nis_plain")}</div><span className={"col-title"}>
                                    <AmountFormat amount={-document?.meta?.applied_fee_value} decimals={2} />
                                </span></div>
                                <div className={"branch-col-val"}><div className="mob-label">{t("management_fee_percent_plain")}</div><span className={"col-title"}>
                                    <AmountFormat amount={document?.meta?.applied_fee_percentage} decimals={2} />%
                                </span></div>
                                <div className={"bankname-col-val"}><div className="mob-label">{t("portfolio_value_plain")}</div><span className={"col-title"}>
                                    <AmountFormat amount={document?.meta?.portfolio_nis_value} decimals={2} />
                                </span></div>
                                <div className={"name-col-val"}>
                                    <div className="mob-label">{t("date_tag_plain")}</div>
                                    <DateFormat date={document?.dt} lang="en" />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )
            }
        >
        </DocumentDetailsPage>
    );
}

export default FeesDetails;
